import { render, staticRenderFns } from "./swiper-card2.vue?vue&type=template&id=23f3139b&scoped=true&"
import script from "./swiper-card2.vue?vue&type=script&lang=js&"
export * from "./swiper-card2.vue?vue&type=script&lang=js&"
import style0 from "./swiper-card2.vue?vue&type=style&index=0&id=23f3139b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f3139b",
  null
  
)

export default component.exports